import * as React from 'react'

import { useSwipeable } from 'react-swipeable'

import { isEventFromOwnDom } from '~/client/src/shared/utils/isEventFromOwnDom'

interface SwipeableWrapperProps {
  children: React.ReactNode
  onSwipedRight?: (eventData: any) => void
  onSwipedLeft?: (eventData: any) => void
  onSwipedUp?: (eventData: any) => void
  onSwipedDown?: (eventData: any) => void
  onSwiped?: (eventData: any) => void
  onSwiping?: (eventData: any) => void
  onSwipeStart?: (eventData: any) => void
  onTap?: (eventData: any) => void
  preventScrollOnSwipe?: boolean
  delta?: number
  trackMouse?: boolean
  trackTouch?: boolean
  rotationAngle?: number
  className?: string
  style?: React.CSSProperties
}

const SwipeableWrapper: React.FC<SwipeableWrapperProps> = ({
  children,
  onSwipedRight,
  onSwipedLeft,
  onSwipedUp,
  onSwipedDown,
  onSwiped,
  onSwiping,
  onSwipeStart,
  onTap,
  preventScrollOnSwipe,
  delta,
  trackMouse,
  trackTouch,
  rotationAngle,
  className,
  style,
}) => {
  const { onMouseDown, ...handlers } = useSwipeable({
    onSwipedRight,
    onSwipedLeft,
    onSwipedUp,
    onSwipedDown,
    onSwiped,
    onSwiping,
    onSwipeStart,
    onTap,
    preventScrollOnSwipe,
    delta,
    trackMouse,
    trackTouch,
    rotationAngle,
  })

  return (
    <div
      {...handlers}
      onMouseDown={
        onMouseDown &&
        (e => {
          if (isEventFromOwnDom(e)) onMouseDown(e)
        })
      }
      className={className}
      style={style}
    >
      {children}
    </div>
  )
}

export default SwipeableWrapper
